module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-005"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_vm._v("THE RESTORATION OF GOMER"), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+3%3A1-5&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 3:1-5")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The prostitute with whom Hosea joined himself was a prophetic anticipation of the Gentiles purchased in the new covenant (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v("). The Jews now suffer, deprived of their hope and their temple worship, but will be saved in the end when the time of the Gentiles is fulfilled (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Manna from heaven is given on the Christian Lord’s day, not during the Jewish sabbath. This is a clear reference to the Eucharist. The prophecy that there would be no more king, altar, victory or priesthood was fulfilled with the destruction of the temple. This indicates that God intended to turn toward the Gentiles (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). There is promised here the future salvation of the Jews because Christ is the king David foretold to save the human race, especially the house of Israel (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-042"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:2"), _c('i', [_vm._v(" Gomer Redeemed")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URCHASE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RICE.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MBROSE")]), _vm._v(": Those are the seven and eight of which Hosea says that with this number he bought and took to himself the fullness of faith, for you read, “And I went and bought her to me for fifteen pieces of silver and for a core of barley and for a half core of barley and a measure of "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("wine.” The Lord had told him previously to buy a harlot, and it is proof that he bought her, since he declares how much he paid. The fifteen pieces of silver consist of seven and eight. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 50.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANY")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AYS")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EQUIRED TO")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETURN.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": And how shall I speak of the whore married by the prophet? She is the figure either of the church as gathered in from the Gentiles, or—an interpretation that better suits the passage—of the synagogue. She, Israel, was first adopted from among the idolaters by Abraham and Moses. She has now denied the Savior and proved unfaithful to him. Therefore she has long been deprived of her altar, priests and prophets and has to abide many days to return to her first husband."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" For when the faithfulness of the Gentiles shall be fulfilled, all Israel shall be saved."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTER 123.13.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-043"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:4"), _c('i', [_vm._v(" Without King or Sacrifice")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD’S")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY AND THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABBATH")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPARED.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": I ask, therefore, on what day the heavenly manna began to be given. I wish to compare our Lord’s day with the sabbath of the Jews. For the divine Scriptures it appears that manna was first given on earth on the Lord’s day. For if, as Scripture says, it was gathered for six consecutive days, but on the seventh day, which is the sabbath, it was stopped, without doubt it began on the first day, which is the Lord’s day. But if it is plain from divine Scriptures that on the Lord’s day God rained manna and on the sabbath he did not, let the Jews understand that already at that time our Lord’s day was preferred to the Jewish sabbath. Even then it was revealed that on their own sabbath no grace of God descended to them from the sky; no bread of heaven, which is the Word of God, came to them. For a prophet also says elsewhere, “The sons of Israel will sit for many days without a king, without a prince, without a prophet, without a victim, without a sacrifice, without a priest.” On our Lord’s day, however, the Lord always rains manna from the sky. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XODUS 7.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN80",
      "id": "ap_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION OF THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTILES")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHESIED.")])]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": For the prophecy was fulfilled that had declared, “For the children of Israel shall abide many days without king and prince. There shall be no victim, nor altar, nor priesthood, nor answers.” These testimonies, accordingly, we employ against those who presume to assert that what is spoken in Genesis by Jacob refers to Judah."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN81",
      "id": "ap_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" They say that there still remains a prince of the race of Judah—he, namely, who is the prince of their nation, whom they style patriarch—and that there cannot fail [a ruler] of his seed, who will remain until the advent of that Christ whom they picture themselves. But if the prophet’s words are true when he says, “The children of Israel shall abide many days without a king, without prince; and there shall be no victim, nor altar, nor priesthood,” and if, certainly, since the overthrow of the temple, victims are neither offered, nor any altar found, nor any priesthood exists. So it is most certain that, as it is written, princes have departed from Judah and a leader from between his thighs, until the coming of him for whom it has been reserved. It is established, then, that he has indeed come from whom it has been reserved and in whom is the expectation of the Gentiles. And this manifestly seems to be fulfilled in the multitude of those who have believed in God through Christ out of the different nations. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRST")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPLES 4.1.3.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN82",
      "id": "ap_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-044"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3:5"), _c('i', [_vm._v(" The Children of Israel Return")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETURNING TO THE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": But let us hear what Hosea goes on to say: “And after this the children of Israel shall return and shall seek the Lord their God and David their king; and they shall fear the Lord and his goodness in the last days.” You will never find a prophecy plainer than this, for the name King David means Christ, who, as Paul says, “was born according to the flesh of the offspring of David.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN83",
      "id": "ap_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Further on still, Hosea foretold the resurrection of Christ on "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("the third day, but in the mysterious way that is proper to prophecy. He says, “He shall heal us after two days, and on the third day we shall rise up again.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN84",
      "id": "ap_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" This is the theme underlying the words of Paul: “Therefore if you have risen with Christ, seek the things that are above.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN85",
      "id": "ap_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITY OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD 18.28.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN86",
      "id": "ap_NFIN86-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09396282","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap6.vue
// module id = 96
// module chunks = 0